import React from "react";
import { useTranslation } from "react-i18next";
import { getImage } from "../../services/ImageService";
import { LanguageSelectionButton } from "../LanguageSelectionButton/LanguageSelectionButton";

export function LanguageSelection() {
    const { t, i18n } = useTranslation();

    function changeLanguage(language) {
        i18n.changeLanguage(language);
        localStorage.setItem("selectedLanguage", language);
    }

    return (
        <div className="group relative mr-12 h-full flex items-center items-center cursor-pointer select-none lg:mr-0">
            <div className="bg-[#368E66] z-20 relative text-[14px] font-bold text-white h-full w-full flex items-center hover:text-primary-accent-hovered mr-2">
                {t(i18n.resolvedLanguage)}
                <div className="w-5 pl-2 mt-1">
                    <img
                        src={getImage("menu_down_white")}
                        className="w-full"
                    />
                </div>
            </div>
            <div className="hidden group-hover:flex absolute right-0 flex flex-col bg-[#3A9E70] z-10 w-max top-24 select-none overflow-y-auto max-h-[56rem]">
                <LanguageSelectionButton
                    content={t("english")}
                    onClick={() => changeLanguage("en")}
                />
                <LanguageSelectionButton
                    content={t("swedish")}
                    onClick={() => {
                        changeLanguage("sv");
                    }}
                />
            </div>
        </div>
    );
}
